import type { TypeChauffage } from "@machine/form.machine"

export type OptionTypeChauffage = { label: string; value: TypeChauffage }

/**
 * Choix proposés au ménage en appartement pour « Vous avez du chauffage : ».
 *
 * Un chauffage est individuel ou collectif (règle de périmètre de Mélodie du
 * 18/09/2026). « Individuel et collectif » (`individuel_et_collectif`) a été
 * retiré de la saisie le 20/09/2026 : api-ww refuse en 400 toute écriture qui
 * le porte sur `type_chauffage` (vérifié le 19/10/2026 dans api-ww,
 * `cstb-validation/perimetre-logement.ts`, `VALEURS_RETIREES_DE_LA_SAISIE`,
 * appliqué par `BuildingService.updateBuilding`). Ce choix menait de toute
 * façon le ménage à l'écran « Logement non éligible » (garde `is_invalid` de
 * la machine), et comme le formulaire renvoie la fiche logement entière à
 * chaque écran, le refus laissait sa fiche vide en base (DEV-2430). Il ne
 * doit donc plus être proposé ici.
 *
 * « Autre/Je ne sais pas » a été retiré lui aussi (décision de Mathieu du
 * 19/10/2026, dans la ligne du back-office qui ne le propose plus depuis le
 * 21/09) : un chauffage est individuel ou collectif, et une saisie « autre »
 * revenait au copilote en « hors vocabulaire ». api-ww l'accepte encore à
 * l'écriture, c'est donc la liste, et le `oneOf` du schéma, qui l'écartent.
 */
export const optionsChauffage: OptionTypeChauffage[] = [
    {
        label: "Individuel uniquement",
        value: "individuel",
    },
    {
        label: "Collectif uniquement",
        value: "collectif",
    },
]

/**
 * Choix proposés pour « Votre eau chaude sanitaire est-elle : ».
 *
 * ⚠️ L'eau chaude sanitaire garde sa liste entière, « Individuel et
 * collectif » compris : api-ww accepte cette valeur sur
 * `type_eau_chaude_sanitaire` (vérifié le 19/10/2026, `ENUM_TYPE_ECS` dans
 * `client/src/constants/logement-fields.ts` : la décision du 18/09 nomme le
 * chauffage, pas l'ECS). Le retrait ne vaut que pour le type de chauffage,
 * c'est pourquoi les deux listes, jusqu'ici partagées, sont dédoublées ici.
 * Comme « Collectif uniquement », ce choix mène le ménage à l'écran
 * « Logement non éligible » (garde `is_invalid`) : c'est la règle du
 * programme, pas un défaut.
 */
export const optionsEauChaudeSanitaire: OptionTypeChauffage[] = [
    {
        label: "Individuel uniquement",
        value: "individuel",
    },
    {
        label: "Collectif uniquement",
        value: "collectif",
    },
    {
        label: "Individuel et collectif",
        value: "individuel_et_collectif",
    },
    {
        label: "Autre/Je ne sais pas",
        value: "autre",
    },
]
